import axios from 'axios';

let baseUrl = "http://distribute.cloudjoys.com:8030/merchantPerform"

//let baseUrl = "http://127.0.0.1:8080/merchantPerform"

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

const http = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': localStorage.getItem('token')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

const httpPost = (url, params) => {
    return axios({
        method: "POST",
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('token')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                return JSON.stringify(data)
            }
        ]
    });
};

const httpGet = (url, params) => {
    return axios({
        method: "GET",
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': localStorage.getItem('token')
        },
        params: params,
        traditional: true,
		transformRequest: [
		    function(data) {
		        let ret = ''
		        for (let it in data) {
		            ret +=
		                encodeURIComponent(it) +
		                '=' +
		                encodeURIComponent(data[it]) +
		                '&'
		        }
		        return ret
		    }
		]
    });
};

export {
    loginreq,
    req,
	http,
	httpPost,
	httpGet,
    baseUrl
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js